import { Button } from '../../ui/Button';
import { Logo } from '../../ui/Logo';

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col items-center justify-center gap-4 px-4 text-center">
      {children}
    </main>
  );
}

export function LoadingScreen() {
  return (
    <Centered>
      <Logo />
      <p role="status" className="text-muted">
        Opening Tahi…
      </p>
    </Centered>
  );
}

export function OtherTabScreen() {
  return (
    <Centered>
      <Logo />
      <p>Tahi is open in another tab or window. Close it, then reload this one.</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Centered>
  );
}

export function FailedScreen({ message }: { message: string }) {
  return (
    <Centered>
      <Logo />
      <p>Tahi couldn't open its data on this device.</p>
      <p className="text-xs text-muted">{message}</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Centered>
  );
}
